import UserInfo from "./UserInfo";

export default class UserInfoResponse {
    constructor(
       public userInfo: UserInfo,
       public errorMessages: string[],
    ) {}
}